<template>
  <generic-page title="Link bank">
    <p>The whole bank linking process</p>
    <app-button>test</app-button>
  </generic-page>
</template>
